// @flow
import * as types from "../ACTIONS/commonActionTypes";
import initialState from './commonInitialState';

export default function magTypeReducer(state = initialState.magTypes, ourClientId:number, action) {

    switch (action.type) {

        case types.GOT_MAG_TYPES_LIST:
            return {
                initialized: true,
                items: action.magTypes
            };
        default:
            return state;
    }
}
    